/**
 * Centralized error reporting for editor operations.
 *
 * Every error is logged to console AND displayed in the UI.
 * Individual call sites cannot opt out of logging — the architecture
 * guarantees it.
 */
import { useCallback } from 'react';
/**
 * Create an ErrorReporter that logs to console and calls a UI notification callback.
 *
 * @param onDisplayError - Callback to show the error in the UI (e.g., setError state setter)
 */
export function useErrorReporter(onDisplayError) {
    const report = useCallback((message) => {
        console.error('[editor]', message);
        onDisplayError(message);
    }, [onDisplayError]);
    return { report };
}
//# sourceMappingURL=useErrorReporter.js.map